// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "Web前端开发技术",
        "tec": "关颖",
        "week": "1-8周",
        "add": "实训楼F座606信机"
      },
      {
        "sub": "离散数学",
        "tec": "张楠",
        "week": "9-16周",
        "add": "教学楼C座111教务"
      }
    ],
    {
      "sub": "数据库原理与应用",
      "tec": "孙宪丽",
      "week": "1-16周",
      "add": "教学楼C座305教务"
    },
    {
      "sub": "物理实验",
      "tec": "孙丽媛",
      "week": "1-12周",
      "add": "教学楼B座214"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "大学英语听说（三）",
      "tec": "吕双双",
      "week": "1-16周",
      "add": "实训楼F座303信息"
    },
    {
      "sub": "软件工程",
      "tec": "吴赜书",
      "week": "1-16周",
      "add": "实训楼F座303信息"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "果金凤",
      "week": "1-12周",
      "add": "教学楼C座311教务"
    },
    {
      "sub": "科技文献检索",
      "tec": "勇世英",
      "week": "1-4周",
      "add": "教学楼D座515信息AISEC"
    },
    {
      "sub": "形势与政策",
      "tec": "单超",
      "week": "1-4周",
      "add": "教学楼C座213教务"
    }
  ],
  "3": [
    {
      "sub": "概率论与数理统计",
      "tec": "李昕姝",
      "week": "1-16周",
      "add": "教学楼D座515信息AISEC"
    },
    {
      "sub": "数据库原理与应用",
      "tec": "孙宪丽",
      "week": "1-16单周",
      "add": "教学楼C座304教务"
    },
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "Web前端开发技术",
        "tec": "关颖",
        "week": "1-8周",
        "add": "实训楼F座606信机"
      },
      {
        "sub": "离散数学",
        "tec": "张楠",
        "week": "9-16周",
        "add": "实训楼F座301信息"
      }
    ],
    {
      "sub": "大学英语读写（三）",
      "tec": "吕双双",
      "week": "1-12周",
      "add": "实训楼F座303信息"
    },
    0,
    [
      {
        "sub": "体育（三）",
        "tec": "郝策",
        "week": "1-12,14-18周",
        "add": "男乒"
      },
      {
        "sub": "男网",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "搏击",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女乒",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "李莉",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女羽",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "健美操",
        "tec": "李灏",
        "week": "1-18周",
        "add": "男乒"
      }
    ],
    0
  ],
  "5": [
    [
      {
        "sub": "概率论与数理统计",
        "tec": "李昕姝",
        "week": "1-16双周",
        "add": "教学楼D座515信息AISEC"
      },
      {
        "sub": "软件工程",
        "tec": "吴赜书",
        "week": "1-16单周",
        "add": "实训楼F座301信息"
      }
    ],
    {
      "sub": "中国近现代史纲要",
      "tec": "果金凤",
      "week": "1-12周",
      "add": "教学楼C座305教务"
    },
    {
      "sub": "明辨性思维",
      "tec": "王淑慧",
      "week": "1-16周",
      "add": "教学楼D座422信息AISEC"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
